import gql from 'graphql-tag'

const subsidiaries = gql`query GetSubsidiaries {
  subsidiaries {
    displayText
    alias {
      alias
    }
    blurb {
      html
    }
    cardImage {
      urls
    }
    cardLogo {
      urls
    }
  }
}`

const subsidiaryDetails = gql`query GetSubsidiaryDetails($alias: String!) {
  subsidiaries(where: {alias: {alias: $alias}}) {
    displayText
    alias {
      alias
    }
    bannerImage {
      urls
    }
    bannerPattern {
      urls
    }
    openingTitle
    logo {
      urls
    }
    primaryColour
    flow {
      contentItems {
        ... on ClientStats {
          bag {
            contentItems {
              ... on StatBlock {
                displayText
                statQuantity
              }
            }
          }
          backgroundImage {
            urls
          }
        }
        ... on ContentBlockFlowpart {
          displayText
          contentBlockSubtitle
          markdownBody {
            html
          }
          image {
            urls
          }
          imagePosition
        }
        ... on Carousel {
          displayText
          textColour
          slides {
            contentItems {
              ... on CarouselSlide {
                displayText
                slideCopy {
                  html
                }
                subtitle
                image {
                  urls
                }
                imagePosition
              }
            }
          }
        }
      }
    }
  }
}`

export {
  subsidiaries,
  subsidiaryDetails
}